module.exports = __webpack_public_path__ + "static/media/opencamicon.5d29313e.svg";